/**
 * Get the current Amazon Publisher Services object.
 *
 * This object cannot be injected because APS sometimes replaces it on the
 * window object wholesale.
 *
 * @returns {*|{}}
 */
export const getApstag = () => (
  ('object' === typeof apstag) ? window.apstag : {});

/**
 * Replace multiple substrings according to a map object.
 *
 * The map should consist of key value pairs where the key equals the substring
 * to be replaced, and the value equals the replacement string.
 *
 * @link https://stackoverflow.com/a/15604206/1801260
 *
 * @param {string} subject
 * @param {object} map
 * @returns string
 */
export const replaceMultiple = (subject, map) => {
  const pattern = new RegExp(Object.keys(map).join('|'), 'gi');
  return subject.replace(pattern, (matched) => map[matched]);
};
